import { css } from '@emotion/react';

export default css`
  :root {
    --header-height: 56px;
    --z-index-dialog: 1300;
  }

  html,
  body {
    margin: 0;
    scroll-behavior: smooth;
  }

  body {
    display: flex;
    flex-direction: column;
  }
`;
